import featureTestsSaga from './feature-tests.saga';

export default featureTestsSaga;
